// src/hooks/useAutoLogout.ts
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const AUTO_LOGOUT_MINUTES = 10; // 10 minutes
const AUTO_LOGOUT_TIME = AUTO_LOGOUT_MINUTES * 60 * 1000; // ms

const useAutoLogout = () => {
  const navigate = useNavigate();
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const resetTimer = () => {
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      sessionStorage.clear();
      localStorage.removeItem("appSettings");
      navigate("/logout");
    }, AUTO_LOGOUT_TIME);
  };

  useEffect(() => {
    const events = ["click", "mousemove", "keydown", "scroll", "touchstart"];

    const handleActivity = () => {
      resetTimer();
    };

    for (const event of events) {
      window.addEventListener(event, handleActivity);
    }

    resetTimer(); // Start the timer on mount

    return () => {
      for (const event of events) {
        window.removeEventListener(event, handleActivity);
      }
      if (timer.current) clearTimeout(timer.current);
    };
  }, [navigate]);
};

export default useAutoLogout;
